import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import RepositorySelector from './view.tsx';

export default withFireUiAnalytics({
	onAdd: 'addRepository',
})(RepositorySelector);
